'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Serializer = require('../../../types/Serializer.cjs');
var DateTime = require('../../../types/DateTime.cjs');

/**
 * The endDate guard is used to specify a date to end the mint.
 * Any transaction received after the end date will fail.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const endDateGuardManifest = {
  name: 'endDate',
  settingsBytes: 8,
  settingsSerializer: Serializer.mapSerializer(Serializer.createSerializerFromBeet(mplCandyGuard.endDateBeet), settings => ({
    date: DateTime.toDateTime(settings.date)
  }), settings => settings)
};

exports.endDateGuardManifest = endDateGuardManifest;
//# sourceMappingURL=endDate.cjs.map
